import { baseThemeValues } from 'constants/common';

const baseButtonProps = {
  borderRadius: '36px',
  borderWidth: '2px',
  boxShadow: 'palette.transparent',
  fontFamily: baseThemeValues.inherit,
  fontSize: '18px',
  fontWeight: 700,
  outlineColor: 'palette.transparent',
  outlineWidth: '0px',
};

export const menuButtonTheme = {
  base: {
    ...baseButtonProps,
    bg: 'palette.surface.5',
    borderColor: 'palette.surface.1',
    text: 'palette.tertiary.50',
  },
  baseProps: baseButtonProps,
  focus: {
    ...baseButtonProps,
    bg: 'palette.primary.50',
    borderColor: 'palette.primary.50',
    text: 'palette.primary.99',
  },
  hover: {
    ...baseButtonProps,
    bg: 'palette.primary.20',
    borderColor: 'palette.primary.20',
    text: 'palette.primary.99',
  },
  pressed: {
    ...baseButtonProps,
    bg: 'palette.primary.20',
    borderColor: 'palette.primary.20',
    outlineColor: 'palette.primary.60',
    outlineWidth: '4px',
    text: 'palette.primary.99',
  },
};
